<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neSelectClick' :typeCode="10006"></NeList>
    </template>
    <template v-slot:right_view>
      <DataTableMenu @methodEnum='methodEnum' ref="dataTableMenu"></DataTableMenu>
      <DataTable ref="datatable"></DataTable>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import DataTableMenu from '../../../components/subscriberconfig/dataManager/DataTableMenu';
import DataTable from '../../../components/subscriberconfig/dataManager/DataTable';
import NeList from '../../../components/common/NeList';

export default {
  name: 'DataManagement',
  components: {
    BasicLayout,
    DataTableMenu,
    DataTable,
    NeList
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('PDN.nelist'),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('DataManagent.crumb'),
      },
      netype: [4, 12, 14], // 4 hss和ibs-hss,12 mc-cms, 14, mc-gms
    };
  },
  props: [
  ],
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'delete':
          this.$refs.datatable.deleteLog();
          break;
        case 'import':
          this.$refs.datatable.openImportPage();
          break;
        case 'export':
          this.$refs.datatable.exportFun();
          break;
        case 'search':
          this.$refs.datatable.refreshData();
          break;
        default:
      }
    },
    neSelectClick() {
      this.$refs.datatable.initLogData(this.$refs.neList.getNe());
    }
  },
  mounted() {
    return null;
  }
};
</script>

<style scoped>

</style>
